import { atom } from "jotai";

export enum Theme {
  Dark,
  Light,
}

export const themeAtom = atom<{
  mode: Theme;
}>({
  mode: localStorage.getItem("theme_mode") === "1" ? Theme.Light : Theme.Dark,
});
